import axios from 'axios';
import _ from 'lodash';
import { push } from 'react-router-redux';

import cfg from '../config';

export const USER_SIGN_IN = "user/SIGN_IN";
export const USER_SIGN_IN_ERROR = "user/SIGN_IN_ERROR";
export const USER_SIGN_OUT = "user/SIGN_OUT";
export const USER_SIGN_OUT_ERROR = "user/SIGN_OUT_ERROR";
export const USER_GET_INFO = "user/GET_INFO";
export const REMOVE_ERROR = "user/REMOVE_ERROR";

const initialState = {
  isLoggedIn: false,
  user: null,
  error: false,
  errorCode: 403,
  timestamp: Date.now()
}

export default (state = initialState, action) => {
  switch (action.type) {
    case USER_SIGN_IN:
      return {
        ...state,
        isLoggedIn: true,
        error: false,
        timestamp: Date.now()
      }

    case USER_SIGN_IN_ERROR:
      return {
        ...state,
        error: true,
        errorCode: action.payload,
        timestamp: Date.now()
      }

    case REMOVE_ERROR:
      return {
        ...state,
        error: false,
        timestamp: Date.now()
      }

    case USER_SIGN_OUT:
      return {
        ...state,
        user: null,
        isLoggedIn: false,
        timestamp: Date.now()
      }

    case USER_GET_INFO:
      return {
        ...state,
        user: _.cloneDeep(action.data),
        isLoggedIn: action.data ? true : false,
        timestamp: Date.now()
      }

    default:
      return state
  }
}

export const signIn = (username, password) => {
  return dispatch => {
    dispatch({type: REMOVE_ERROR});
    axios.post(cfg.api.signIn, {
      username: username,
      password: password
    })
    .then((response) => {
        console.log(response);
        dispatch({type: USER_SIGN_IN});
        dispatch(push('/'));
    })
    .catch((error) => {
       console.log(error);
       dispatch({type: USER_SIGN_IN_ERROR, payload: error.response.status});
    });
  }
}

export const signOut = () => {
  return dispatch => {
    axios.get(cfg.api.signOut)
    .then((response) => {
        console.log(response);
        dispatch({type: USER_SIGN_OUT});
        dispatch(push('/sign'));
    })
    .catch((error) => {
       console.log(error);
       dispatch({type: USER_SIGN_OUT_ERROR});
    });
  }
}

export const getUserInfo = () => {
  return dispatch => {
      axios.get(cfg.api.getUser)
      .then((response) => {
          dispatch({type: USER_GET_INFO, data: response.data});
      })
      .catch((error) => {
         console.log(error);
         dispatch({type: USER_GET_INFO, data: null});
      });
  }
}


// WEBPACK FOOTER //
// ./src/reducers/user.js